import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Volume2, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const ListenButton = ({ text, className = "" }) => {
  const [busy, setBusy] = useState(false);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  const stop = () => {
    audioRef.current?.pause();
    audioRef.current = null;
    setPlaying(false);
  };

  const play = async () => {
    if (playing) return stop();
    setBusy(true);
    try {
      const { data } = await api.post("/tts/speak", { text }, { responseType: "blob", timeout: 45000 });
      const url = URL.createObjectURL(data);
      const audio = new Audio(url);
      audioRef.current = audio;
      audio.onended = () => { setPlaying(false); URL.revokeObjectURL(url); };
      await audio.play();
      setPlaying(true);
    } catch {
      toast.error("Could not play audio right now");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={play}
      disabled={busy}
      data-testid="listen-btn"
      aria-label={playing ? "Stop audio" : "Listen to this listing"}
      className={`inline-flex items-center gap-1.5 text-xs transition-colors ${playing ? "text-[#FF3B30]" : "text-neutral-400 hover:text-white"} ${className}`}
    >
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : playing ? <Square className="h-3.5 w-3.5" /> : <Volume2 className="h-3.5 w-3.5" />}
      {playing ? "Stop" : "Listen"}
    </button>
  );
};
